import EducationBar from "../components/EducationBar/EducationBar";
import withEducationDataFromWindow from "app/pages/sales-intelligence/hoc/withEducationDataFromWindow";

const EducationBarFromWindowContainer = withEducationDataFromWindow(EducationBar);

export default EducationBarFromWindowContainer;
